// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogNl = {
  "controls": {
    "boot": "Opstarten",
    "reset": "Resetten",
    "copyScreen": "Scherm Kopiëren",
    "copyText": "Tekst kopiëren",
    "pasteText": "Tekst Plakken",
    "saveState": "Status Opslaan",
    "restoreState": "Status Herstellen",
    "toggleSound": "Geluid Omschakelen",
    "settings": "Instellingen",
    "infoPanel": "Informatiepaneel",
    "reportIssue": "Een probleem melden",
    "privacyPolicy": "Privacybeleid"
  },
  "config": {
    "speed": "Snelheid",
    "display": "Beeldscherm Instellingen",
    "theme": "Thema",
    "openRetroControlPanel": "Bedieningspaneel",
    "resetSettings": "Alle Instellingen Resetten",
    "useOpenApple": "{{modKey}}-toets gebruiken als Open Apple-toets",
    "useShortcuts": "{{modKey}}-toets gebruiken voor sneltoetsen",
    "useArrowKeys": "Pijltjestoetsen als Joystick gebruiken",
    "scanlines": "CRT Scanlijnen",
    "ghosting": "Fosfor Nagloeien",
    "crtDistortion": "CRT Vervorming",
    "joystick": "Joystickconfiguratie"
  },
  "machine": {
    "slotConfigurator": "Uitbreidingssleuven"
  },
  "speed": {
    "snail": "Slakkengang (0.1 MHz)",
    "slow": "Langzaam (0.5 MHz)",
    "normal": "Normaal (1 MHz)",
    "fast": "Snel (4 MHz)",
    "warp": "Belachelijke snelheid"
  },
  "colors": {
    "color": "Kleur",
    "nofringe": "Kleur (geen rand)",
    "green": "Groen",
    "white": "Zwart en Wit",
    "inverse": "Zwart en Wit (omgekeerd)"
  },
  "themes": {
    "classic": "Klassiek",
    "dark": "Donker",
    "minimal": "Minimaal"
  },
  "debug": {
    "helpPanel": "Help panel tonen",
    "debugPanel": "Debug panel tonen",
    "expectinPanel": "Apple exPectin panel tonen",
    "debugTab": "Foutopsporing",
    "memory": "Geheugen",
    "state": "CPU Status",
    "flags": "Vlaggen",
    "step": "Stap",
    "stepOver": "Stap Over",
    "stepInto": "Stap In",
    "stepOut": "Stap Uit",
    "resume": "Hervatten",
    "pause": "Pauze",
    "loadSymbolTable": "Symbolentabel laden"
  },
  "tour": {
    "welcome": "Welkom bij de Apple2TS emulator!",
    "clickNext": "Om meer te leren, druk op de Volgende knop.",
    "bootButton": "Klik hier om de emulator te starten.",
    "resetButton": "Klik hier om de Apple II te resetten en opnieuw op te starten of BASIC in te gaan.",
    "diskImages": "Kies een van de geïnstalleerde disk images.",
    "floppyDisks": "Of klik op een van de floppy disk iconen om een disk image te laden.",
    "saveRestore": "Je kunt de complete status van de emulator opslaan en herstellen met deze knoppen.",
    "themeButton": "Klik hier om het emulator UI thema te wijzigen.",
    "endTour": "Je hebt het einde van de tour bereikt. Klik op de globe tour knop om een van de andere tours te proberen, of druk op Voltooien om de emulator te gebruiken.",
    "tourSelectorHint": "Klik op de wereldboltourknop om een van de andere tours te proberen, of druk op Voltooien om de emulator te gaan gebruiken.",
    "settingsWelcome": "Apple2TS heeft een complete set van bedieningselementen voor zowel de emulator als de Apple II. Om meer te leren, druk op de Volgende knop.",
    "mainControls": "Hier kun je de Apple II opstarten en resetten, status herstellen en opslaan, het scherm kopiëren, of tekst in de emulator plakken.",
    "snapshot": "Op elk moment kun je een snapshot maken van de huidige emulator status, dan terug in tijd gaan naar een eerdere status, of weer vooruitspoelen. Je kunt ook de emulator status opslaan met alle huidige snapshots.",
    "pauseButton": "Je kunt de emulator op elk moment pauzeren, waardoor de 6502 processor bevriest. Dit is handig om de actie in een spel te pauzeren, of de debugger in te gaan.",
    "debugButton": "Klik op het insect om debug modus in te gaan, waar je de interne status van de 6502 processor kunt zien. Klik opnieuw om terug te gaan naar normale modus.",
    "configButtons": "De onderste rij knoppen bestuurt de status van de Apple II, beginnend met de emulator snelheid, schermkleur, en geluid dempen.",
    "keyboardButtons": "Als de caps lock toets aan staat, dan zijn alle getypte karakters HOOFDLETTERS.",
    "altArrowKeys": "De volgende toets bepaalt of de {{modKey}} toets gebruikt wordt voor sneltoetsen of de Apple II Open Apple toets. De laatste toets bepaalt of de pijltjestoetsen gebruikt kunnen worden als de Apple II joystick.",
    "clearCookies": "Apple2TS slaat automatisch de huidige emulator instellingen op als browser cookies. Druk op deze knop om deze instellingen te resetten en de cookies te verwijderen.",
    "debugWelcome": "Apple2TS heeft een rijke set van tools om 6502 assembly code te analyseren en debuggen. Om meer te leren, druk op de Volgende knop.",
    "debugIcon": "Klik op het Insect icoon in de Info tabs om het Debug panel te bekijken.",
    "debugPause": "Druk op de Pauzeer knop om de uitvoering van de emulator te pauzeren of hervatten.",
    "debugControls": "Nu we gepauzeerd hebben, kunnen we stap voor stap door de gedemonteerde code gaan met de Stap Over, In, en Uit knoppen. We kunnen ook snel springen naar het huidige adres van de Program Counter (PC).",
    "debugDisassembly": "Hier zien we de gedemonteerde code, met de hex adressen, de drie-letter instructie, en alle waarden of adressen. Als je je muis over een groene waarde beweegt, verschijnt een tooltip met de huidige waarde. Klikken op een blauw adres scrollt naar die locatie. Je kunt ook in de linker marge klikken om breakpoints toe te voegen of te verwijderen.",
    "debugInfo": "In het midden hebben we de Stack Dump en een Memory Map. De Memory Map werkt real-time bij en toont je welke geheugenbanken momenteel actief zijn.",
    "debugMemory": "Het laatste gedeelte toont het Apple II geheugen. Je kunt de dropdown gebruiken om verschillende delen van het geheugen te onderzoeken. Als je naar een van de HGR pagina's schakelt, krijg je een vergroot beeld van het hires scherm, gekoppeld aan de geheugenlocaties. Je kunt ook zoeken naar hex waarden of ASCII strings, en het geheugen opslaan in een bestand.",
    "back": "Terug",
    "close": "Sluiten",
    "last": "Voltooien",
    "next": "Volgende",
    "nextLabelWithProgress": "Volgende (Stap {step} van {steps})",
    "skip": "Sluiten",
    "guidedTour": "Rondleiding",
    "mainLabel": "Rondleiding: Hoofdmenu",
    "settingsLabel": "Rondleiding: Instellingen",
    "debugLabel": "Rondleiding: Debuggen"
  },
  "disk": {
    "hardDisk": "Harde Schijf",
    "eject": "Disk Uitwerpen",
    "insert": "Disk Invoegen",
    "writeProtected": "Schrijfbeveiligd",
    "readWrite": "Lezen/Schrijven",
    "empty": "Leeg",
    "loading": "Laden...",
    "selectDisk": "Disk Image Selecteren",
    "browse": "Bladeren",
    "newReleases": "Nieuwe Releases",
    "writeProtectDisk": "Disk Schrijfbeveiliging",
    "saveDiskToDevice": "Disk Opslaan",
    "saveDiskTo": "Disk Opslaan op",
    "saveDiskToMenu": "Disk Opslaan op >",
    "addToFavorites": "Toevoegen aan Favorieten",
    "downloadDisk": "Disk Downloaden",
    "downloadWoz": "WOZ-schijfkopie downloaden",
    "downloadAndEjectDisk": "Disk Downloaden en Uitwerpen",
    "ejectDisk": "Disk Uitwerpen",
    "ejectAllDisks": "Alle disks uitwerpen",
    "saveDiskToOneDrive": "Disk Opslaan op OneDrive",
    "saveDiskToGoogleDrive": "Disk Opslaan op Google Drive",
    "loadDisk": "Disk laden",
    "loadAdditionalDisks": "Extra disk laden...",
    "loadDiskFrom": "Disk Laden van",
    "loadDiskFromMenu": "Disk Laden van >",
    "loadDiskFromDevice": "Disk Laden",
    "loadDiskFromDeviceReadOnly": "Disk Laden van Apparaat (Alleen Lezen)",
    "loadDiskFromDeviceReadWrite": "Disk Laden van Apparaat (Lezen/Schrijven)",
    "loadDiskFromInternetArchive": "Disk Laden van Internet Archive",
    "loadDiskFromOneDrive": "Disk Laden van OneDrive",
    "loadDiskFromGoogleDrive": "Disk Laden van Google Drive",
    "insertBlankDisk": "Lege disk invoegen",
    "syncEveryMinute": "Elke Minuut Synchroniseren",
    "syncEvery5Minutes": "Elke 5 Minuten Synchroniseren",
    "pauseSyncing": "Synchronisatie Pauzeren",
    "syncNow": "Nu Synchroniseren",
    "modified": "gewijzigd",
    "synced": "gesynchroniseerd",
    "diskDrivesAndDevices": "diskdrives en apparaten",
    "syncedAt": "Gesynchroniseerd {{date}}",
    "clickToLoadDiskImage": "Klik om disk-image(s) te laden",
    "clickToRemoveFromDiskCollection": "Klik om uit diskcollectie te verwijderen",
    "clickToAddToDiskCollection": "Klik om aan diskcollectie toe te voegen",
    "byCreator": "door {{creator}}",
    "clickToViewDetails": "Klik om details te bekijken",
    "standbyDisks": "Stand-by schijven (Klik om van schijf te wisselen)"
  },
  "help": {
    "title": "Apple2TS",
    "credit": "(c) {{year}} Chris Torrence en de Apple2TS-bijdragers",
    "keyboardShortcuts": "Sneltoetsen",
    "shortcutsUnavailable": "Emulatorsneltoetsen met {{keyMod}} zijn niet beschikbaar zolang die toets aan Open Apple is toegewezen. Met Ctrl+0 tot en met Ctrl+5 kunt u nog steeds de emulatorsnelheid kiezen.",
    "diskContainers": "Gecomprimeerde archieven:",
    "multiDiskNotice": "Wisselen van meerdere schijven: Klik op de multi-schijf-badge om het snelwisselmenu te openen. Multi-schijfarchieven (.zip, .7z, .gz) worden automatisch in de wissellijst geladen.",
    "urlParameters": "Optionele URL Parameters",
    "examples": "Voorbeelden",
    "mobileInstructions": "Mobiele platforms:",
    "tapScreen": "Tik op het scherm om het toetsenbord te tonen.",
    "arrowKeys": "Druk op de pijltjestoetsen, esc, of tab knoppen om die toetsen naar de emulator te sturen.",
    "ctrlKey": "Om een control karakter te versturen, druk eenmaal op de ctrl knop. Tik dan op het scherm om het toetsenbord te tonen en druk op de gewenste toets. De ctrl knop wordt automatisch losgelaten.",
    "ctrlLock": "Om meerdere control karakters te versturen, druk tweemaal op de ctrl knop om het te vergrendelen (aangegeven door een groene stip). Tik dan op het scherm om het toetsenbord te tonen en druk op de gewenste toetsen. Druk opnieuw op de ctrl knop om het los te laten.",
    "appleKeys": "De open apple en closed apple toetsen gedragen zich hetzelfde als de ctrl toets.",
    "openAppleKey": "Open Apple: druk op Linker Alt/Option",
    "closedAppleKey": "Closed Apple: Druk Rechter Alt/Option",
    "joystickKeys": "Joystick-toetsen: Numeriek toetsenbord 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "Voor schermtoetsenbord, CTRL of ESC gebruiken:\ntoets eenmalig aanraken om te activeren dan gewenste toets.",
    "urlParametersBody": "Voor optionele URL-parameters voegt u deze toe aan de URL na een vraagteken (?) en scheidt u meerdere parameters met een ampersand (&). Gebruik # om de schijfkopie op te geven. Zie het dialoogvenster Link Builder voor voorbeelden.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay met debugging",
      "totalReplayChoplifter": "Total Replay, laad Choplifter, ingesloten modus",
      "a2Desktop": "A2DeskTop 2MG met hoge snelheid en kleur",
      "embeddedBasic": "Ingesloten Applesoft BASIC Programma",
      "binaryHexAddress": "Binair Bestand met Hex Adres"
    },
    "resourceLinks": {
      "desktopApp": "Apple2TS Desktop-app",
      "corsProxy": "CORS Proxy by Corsfix",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "Laden...",
    "error": "Fout",
    "success": "Succes",
    "confirm": "Bevestigen",
    "cancel": "Annuleren",
    "on": "aan",
    "off": "uit",
    "confirmTheme": "De emulator herladen en dit thema nu toepassen?",
    "confirmReset": "Alle instellingen naar standaardwaarden resetten?",
    "fileNotFound": "Bestand niet gevonden",
    "invalidFile": "Ongeldig bestandsformaat",
    "diskInserted": "Disk ingevoegd",
    "diskEjected": "Disk uitgeworpen"
  },
  "keyboard": {
    "space": "Spatie"
  },
  "audio": {
    "speaker": "Luidspreker",
    "midi": "MIDI",
    "configuration": "Audioconfiguratie",
    "mute": "Dempen",
    "waveform": "Golfvorm"
  },
  "print": {
    "print": "Afdrukken",
    "clear": "Wissen",
    "save": "Output Opslaan",
    "dumpScreen": "Huidig scherm naar printer sturen",
    "dumpScreenInverse": "Huidig scherm sturen (Omgekeerd)",
    "sendToPrinter": "Naar printer sturen",
    "tearOff": "Pagina afscheuren en resetten",
    "printedPage": "Afgedrukte pagina",
    "printerConfig": "Printerconfiguratie",
    "pageLength": "Paginalengte",
    "pageLengthA4": "11,7 inch (A4)"
  },
  "device": {
    "machineConfiguration": "Machine Configuratie",
    "midiDeviceSelect": "MIDI Apparaat Selectie",
    "serialPortSelect": "Seriële Poort Selectie",
    "mockingboardWaveform": "Mockingboard Golfvorm"
  },
  "collection": {
    "showApple2TSCollection": "Apple2TS Collectie Tonen",
    "showNewReleases": "Nieuwe Releases Tonen",
    "showFavorites": "Favorieten Tonen",
    "chooseDiskImage": "Disk image kiezen",
    "diskCollection": "Disk collectie",
    "clickToShowDetails": "Klik om details te tonen voor",
    "clickToLoadDisk": "Klik om disk te laden",
    "diskIsNewRelease": "Disk is een nieuwe release",
    "diskIsApple2TSCollection": "Disk is onderdeel van de Apple2TS collectie",
    "diskIsInternetArchive": "Disk is onderdeel van Internet Archive",
    "clickToRemoveFromCollection": "Klik om uit disk collectie te verwijderen",
    "clickToAddToCollection": "Klik om toe te voegen aan schijfverzameling",
    "diskIsSyncedVia": "Disk is gesynchroniseerd via",
    "loadDiskIntoDrive": "Disk Laden in Drive",
    "exportDisksToHdv": "Schijven exporteren naar HDV",
    "export": "Exporteren",
    "clickToRemoveFromSelected": "Klik om te verwijderen uit geselecteerde schijven",
    "clickToAddToSelected": "Klik om toe te voegen aan geselecteerde schijven",
    "reportExportIssue": "Exportprobleem melden"
  },
  "debugControls": {
    "goBackInTime": "Terug in de Tijd",
    "takeSnapshot": "Snapshot Maken",
    "goForwardInTime": "Vooruit in de Tijd",
    "saveStateWithSnapshots": "Status Opslaan met Snapshots",
    "resume": "Hervatten",
    "pause": "Pauzeren",
    "downloadTraceLog": "Trace-logboek downloaden"
  },
  "fullscreen": {
    "fullScreen": "Volledig Scherm"
  },
  "internetArchive": {
    "searchPlaceholder": "Typ de naam van een softwaretitel of klik op een van de categorieën hierboven",
    "go": "GA"
  },
  "basic": {
    "newProgram": "Nieuw programma",
    "runFromBeginning": "Vanaf het begin uitvoeren",
    "break": "Onderbreken",
    "continueRunning": "Uitvoering voortzetten",
    "stepProgram": "Programma stap voor stap uitvoeren",
    "resumeOutput": "Uitvoer hervatten",
    "freezeOutput": "Uitvoer bevriezen",
    "importProgram": "Programma importeren...",
    "exportProgram": "Programma exporteren...",
    "renumberProgram": "Programma hernummeren",
    "rebuildProgram": "Programma reconstrueren vanuit het geheugen",
    "displaySettings": "Weergave-instellingen",
    "autoLineNumbering": "Automatische regelnummering",
    "capitalizeKeywords": "Trefwoorden scrijven in hoofdletters",
    "rebuildWarning": "Dit zal het huidige programma vervangen door een versie die is gereconstrueerd uit het Apple II-geheugen. U raakt eventuele niet-opgeslagen wijzigingen kwijt. Weet u het zeker?",
    "variable": "Variabele",
    "value": "Waarde"
  },
  "expectin": {
    "runScript": "Script uitvoeren",
    "stopScript": "Script stoppen"
  },
  "saveDisassembly": {
    "title": "Disassembly opslaan",
    "startAddress": "Startadres $",
    "endAddress": "Eindadres $",
    "includeLabels": "Inclusief symboollabels",
    "separatorLines": "Scheidingslijnen na JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Pijltoetsen als joystick",
    "siriusJoyport": "Sirius Joyport-modus"
  },
  "traceSettings": {
    "title": "Trace-instellingen",
    "settings": "Instellingen"
  },
  "linkBuilder": {
    "startupOptionsTab": "Opstartopties",
    "speedNames": {
      "warp": "Belachelijk"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "Slotkaarten configureren",
      "slot": "Slot {{slot}}:",
      "cardNone": "Geen (leeg)"
    },
    "additionalDiskDrives": "Extra diskettestations",
    "slot6Drive1": "Slot 6 Station 1 (Diskette 1)",
    "slot6Drive2": "Slot 6 Station 2 (Diskette 2)",
    "slot7Drive1": "Slot 7 Station 1 (Harde schijf 1)",
    "slot7Drive2": "Slot 7 Station 2 (Harde schijf 2)",
    "slot2Drive1": "Slot 2 Station 1 (VERA SD)",
    "slot4Drive1": "Slot 4 Station 1 (VERA SD)",
    "addAdditionalDisk": "Extra schijf toevoegen om te wisselen",
    "removeDisk": "Deze schijf verwijderen",
    "addAnotherDisk": "Nog een schijf toevoegen",
    "diskPlaceholder": "Schijf {num} bestandsnaam (bijv. sideB.woz|Scenarioschijf)"
  },
  "startup": {
    "welcome": "Welkom bij Apple2TS",
    "subtitle": "Apple II Emulator in TypeScript",
    "copyright": "(c) {{year}} C.Torrence + medewerkers",
    "diskCollections": "Klik op het icoon Disk collectie\nom een spel te laden."
  },
  "retroControl": {
    "machine": "Machine",
    "fullscreen": "Volledig scherm",
    "diskCollection": "Disks",
    "diskDrives": "Diskstations",
    "display": "Beeld",
    "monitorMode": "Monitormodus",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Geluid",
    "options": "Opties",
    "skin": "Uiterlijk",
    "personalization": "Personalisatie",
    "text": "Tekst",
    "background": "Achtergrond",
    "border": "Rand",
    "iigsColor": {
      "black": "Zwart",
      "red": "Rood",
      "darkBlue": "Donkerblauw",
      "purple": "Paars",
      "darkGreen": "Donkergroen",
      "darkGray": "Donkergrijs",
      "mediumBlue": "Middelblauw",
      "lightBlue": "Lichtblauw",
      "brown": "Bruin",
      "orange": "Oranje",
      "lightGray": "Lichtgrijs",
      "pink": "Roze",
      "lightGreen": "Lichtgroen",
      "yellow": "Geel",
      "aquamarine": "Aquamarijn",
      "white": "Wit"
    },
    "keyboard": "Toetsenbord",
    "joystick": "Joystick",
    "slots": "Sleuven",
    "devices": "Apparaten",
    "printerPort": "Printerpoort",
    "modemPort": "Modempoort",
    "quit": "Afsluiten",
    "apple2tsCollection": "Apple2TS-verzameling",
    "newReleases": "Nieuwe releases",
    "favorites": "Favorieten",
    "exportDisksToHdv": "Disks naar HDV exporteren",
    "noDiskDrivesAvailable": "Geen diskstations beschikbaar",
    "select": "Selecteren",
    "open": "Openen",
    "load": "Laden",
    "go": "Ga",
    "save": "Opslaan",
    "clipboard": "Klembord",
    "cancelEsc": "Annuleren:Esc",
    "color": "Kleur",
    "systemSpeed": "Systeemsnelheid",
    "other": "Overig",
    "timeMachine": "Momentopnamen",
    "ports": "Poorten",
    "language": "Taal",
    "retroTheme": "Retro",
    "lowercaseInput": "Invoer in kleine letters",
    "openAppleKey": "Open Apple-toets",
    "sortOrder": "Sorteren",
    "card": {
      "empty": "Leeg",
      "mockingboard": "Mockingboard"
    }
  }
}
